module.exports = __webpack_public_path__ + "img/slide-button-links.3a482ac13af7780a23e451f062e7fe7e.svg";